// extracted by mini-css-extract-plugin
export default {"container":"style_container__kx6uq","header":"style_header__uRLzg","photo":"style_photo__FUvFg","actions":"style_actions__tunvh","information":"style_information__+UqQp"};